export default __webpack_public_path__ + "static/image044-901a680445a0844a65d3a85c739f8a28.jpg";